/** Triggers a browser download for a blob. Pulled out of `TransactionAttachmentComponent` so file lists can reuse it. */
export function saveBlobAsFile(blob: Blob, fileName: string): void {
  const downloadBlob = new Blob([blob], { type: blob.type });
  const url = window.URL.createObjectURL(downloadBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
